<template>
  <div class="flex width-100">
    <div class="width-50">
      <h2>Email Data:</h2>

      <GridContainer
        form-container
        class="align-left"
      >
        <el-form
          label-position="left"
          @submit.native.prevent
        >
          <el-form-item label="FullName:">
            <el-input
              v-model="name"
              autofocus
              type="text"
              :placeholder="name"
              clearable
            />
          </el-form-item>

          <el-form-item label="Position:">
            <el-input
              v-model="position"
              type="text"
              :placeholder="position"
              clearable
            />
          </el-form-item>

          <el-form-item label="Email:">
            <el-input
              v-model="email"
              type="text"
              :placeholder="email"
              clearable
            />
          </el-form-item>

          <el-form-item label="Phone Number:">
            <el-input
              v-model="phone"
              type="text"
              :placeholder="phone"
              clearable
            />
          </el-form-item>

          <el-button
            type="primary"
            @click="copySignatureCode"
          >
            Copy HTML Code!
          </el-button>

          <el-button
            type="primary"
            @click="saveSignature"
          >
            Download HTML File!
          </el-button>

          <spacer :span="16" />

          <p>If your email client does not support html code signature, download and open the HTML file, then copy all elements directly to signature editor.</p>
        </el-form>
      </GridContainer>
    </div>

    <div class="vertical-divider width-50">
      <h2>Preview:</h2>

      <spacer :span="24" />

      <div v-html="signature" />
    </div>
  </div>
</template>

<script>
import copy from 'copy-to-clipboard'
import { saveAs } from 'file-saver'

export default {
  name: 'EmailSignature',
  data() {
    return {
      name: '',
      position: '',
      email: '',
      phone: 1234567890
    }
  },
  computed: {
    getUserData() {
      return this.$store.getters.getUserData
    },

    cc() {
      return '(+30)'
    },

    links() {
      return {
        facebook: 'https://www.facebook.com/Owiwi.co.uk/',
        twitter: 'https://twitter.com/Owiwi_HireOnce',
        instagram: 'https://www.instagram.com/owiwi_hr/',
        linkedin: 'https://www.linkedin.com/company/owiwi/',
        website: 'https://owiwi.co.uk'
      }
    },

    images() {
      return {
        facebook: 'https://s7i7c8i2.stackpathcdn.com/social/facebook.png',
        twitter: 'https://s7i7c8i2.stackpathcdn.com/social/twitter.png',
        instagram: 'https://s7i7c8i2.stackpathcdn.com/social/instagram.png',
        linkedin: 'https://s7i7c8i2.stackpathcdn.com/social/linkedin.png',
        website: 'https://s7i7c8i2.stackpathcdn.com/owl-logo.png',
        rewards: 'https://s7i7c8i2.stackpathcdn.com/rewards.jpg'
      }
    },

    company() {
      return {
        name: 'Owiwi',
        address: '28is Oktovriou 4, Athina 106 77, Athens, Greece',
        phone: 2103640924,
        site: 'owiwi.co.uk'
      }
    },

    signature() {
      return `
      <table cellspacing="0" cellpadding="0" border="0">
          <tbody>
          <tr>
              <td style="vertical-align: middle; padding-right: 30px; padding-left: 3px;line-height: normal;">
                  <table cellspacing="0" cellpadding="0" border="0">
                      <tbody>
                      <tr>
                          <td style="padding-bottom: 0px;line-height: normal; ">
                              <span class="js-signature-name" data-input="name" data-tab="info" style="font-family:Impact;font-size:20px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#000000;">${this.name}</span>
                          </td>
                      </tr>
                      <tr>
                          <td style="font-size:15px;padding-bottom:8px;line-height:normal;padding-top:3px;">
                              <span class="js-signature-jobtitle" data-input="jobtitle" data-tab="info" style="font-family:Arial;font-size:15px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#000000;">${this.position}</span>
                              <span class="js-signature-separator-label" style="font-family:Arial;font-size:15px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#000000;">@</span>
                              <span class="js-signature-company" data-input="company" data-tab="info" style="font-family:Arial;font-size:15px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#000000;">${this.company.name}</span>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <span class="js-signature-email-label" style="font-family:Impact;font-size:12px;font-style:normal;font-stretch:normal;line-height:1.7;letter-spacing:normal;color:#000000;font-weight:bold;">E:&nbsp;</span>
                              <a class="js-signature-email" :href="mailto:${this.email}" data-input="email" data-tab="info" style="font-family:Arial;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.7;letter-spacing:normal;color:#000000;text-decoration:none;">${this.email}</a>
                          </td>
                      </tr>
                      <tr>
                          <td style="line-height: normal;">
                              <span class="js-signature-phone-label" style="font-family:Impact;font-size:12px;font-style:normal;font-stretch:normal;line-height:1.7;letter-spacing:normal;color:#000000;font-weight:bold;">T:&nbsp;</span>
                              <a class="js-signature-phone" :href="tel:+30${this.phone}" data-input="phone" data-tab="info" style="font-family:Arial;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.7;letter-spacing:normal;color:#000000;text-decoration:none;">${this.cc} ${this.formatPhone(this.phone)}</a>
                          </td>
                      </tr>
                      <tr>
                          <td style="line-height: normal;">
                              <span class="js-signature-phone-label" style="font-family:Impact;font-size:12px;font-style:normal;font-stretch:normal;line-height:1.7;letter-spacing:normal;color:#000000;font-weight:bold;">M:&nbsp;</span>
                              <a class="js-signature-phone" :href="tel:+30${this.company.phone}" data-input="phone" data-tab="info" style="font-family:Arial;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.7;letter-spacing:normal;color:#000000;text-decoration:none;">${this.cc} ${this.formatPhone(this.company.phone)}</a>
                          </td>
                      </tr>
                      <tr>
                          <td style="padding-bottom: 5px;line-height: normal;">
                              <span class="js-signature-address-label" style="font-family:Impact;font-size:12px;font-style:normal;font-stretch:normal;line-height:1.7;letter-spacing:normal;color:#000000;font-weight:bold;">A:&nbsp;</span>
                              <a class="js-signature-address" href="javascript:;" data-input="address" data-tab="info" style="font-family:Arial;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:1.7;letter-spacing:normal;color:#000000;text-decoration:none;">${this.company.address}</a>
                          </td>
                      </tr>
                      <tr>
                          <td style="padding-right: 5px; height: 16px;line-height: normal;">
                              <a style="text-decoration: none;" class="js-signature-social-facebook" href="${this.links.facebook}">
                                  <img style="height: 16px; padding-right: 2px;" data-input="facebook" data-tab="social" src="${this.images.facebook}">
                              </a>
                              <a style="text-decoration: none;" class="js-signature-social-twitter" href="${this.links.twitter}">
                                  <img style="height: 16px; padding-right: 2px;" data-input="twitter" data-tab="social" src="${this.images.twitter}">
                              </a>
                              <a style="text-decoration: none;" class="js-signature-social-instagram" href="${this.links.instagram}">
                                  <img style="height: 16px; padding-right: 2px;" data-input="instagram" data-tab="social" src="${this.images.instagram}">
                              </a>
                              <a style="text-decoration: none;" class="js-signature-social-linkedin" href="${this.links.linkedin}">
                                  <img style="height: 16px; padding-right: 2px;" data-input="linkedin" data-tab="social" src="${this.images.linkedin}">
                              </a>
                          </td>
                      </tr>
                      </tbody>
                  </table>
              </td>
              <td style="line-height:normal;vertical-align:top;">
                  <table cellspacing="0" cellpadding="0" border="0">
                      <tbody>
                      <tr>
                          <td style="vertical-align:middle;padding-left:0px;padding-bottom:10px;line-height:normal;" valign="middle"><a href="${this.links.website}"><img class="js-signature-logo" src="${this.images.website}" data-input="logo" data-tab="info" alt="" style="width:80px;height:130px;display:block;"></a>
                          </td>
                      </tr>
                      <tr>
                          <td style="line-height: normal;">
                              <a class="js-signature-website" data-input="website" data-tab="info" href="${this.links.website}" style="font-family:Impact;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#000000;">${this.company.site}</a>
                          </td>
                      </tr>
                      </tbody>
                  </table>
              </td>
          </tr>
          <tr>
              <td colspan="2" style="vertical-align:middle;padding-left:0px;padding-top:5px;line-height:normal;" valign="middle">
                  <img class="js-signature-logo" src="${this.images.rewards}" data-input="logo" data-tab="info" alt="" style="width:320px;height:64px;display:block;">
              </td>
          </tr>
          <tr>
            <td colspan="2">
              <hr />
            </td>
          </tr>
          </tbody>
        </table>
        <p style="font-family:Impact;font-size:12px;font-weight:bold;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#000000;">DISCLAIMER:</p>
        <p style="font-family:Arial;font-size:12px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#000000;">Email communication is confidential and intended solely for the addressee(s). Any unauthorized review, use, disclosure or distribution is prohibited. If you believe the email signature has been sent to you in error, please notify the sender by replying to the email transmission and delete the signature without disclosing it. Thank you. Email including attachments is susceptible to data corruption, interception, unauthorized amendment, tampering and viruses, and we only send and receive emails on the basis that we are not liable for any such corruption, interception, amendment, tampering or viruses or any consequences thereof.</p>
      `
    }
  },
  created() {
    this.name = this.getUserData.firstName + ' ' + this.getUserData.lastName
    this.position = this.getUserData.jobTitle.name
    this.email = this.getUserData.email
  },
  methods: {
    formatPhone(val) {
      val = val.toString()
      return [val.slice(0, 3), ' ', val.slice(3, 7), ' ', val.slice(7)].join('')
    },

    copySignatureCode() {
      copy(this.signature)
      alert('Copied to your clipboard!')
    },

    saveSignature() {
      const file = new File([this.signature], 'owiwi_email_signature.html', { type: 'text/html;charset=utf-8' })
      saveAs(file)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .width-50 {
    width: 50%;
  }

  .align-left {
    margin-left: 0;
  }

  .vertical-divider {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: - ($-padding-unit * 4);
      width: 1px;
      background-color: $-color-silver;
    }
  }
</style>
